module.exports = __webpack_public_path__ + "img/update.594e65eb.svg";